module.exports = __webpack_public_path__ + "img/img22.1f816aeb.jpg";